var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgDashboard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 20,
    fill: "white",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 15,
    fontSize: 12,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Job Management"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 60,
    height: 20,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 45,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Open-"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60,
    width: 30,
    height: 20,
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Closed-"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90,
    width: 140,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 105,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Jobs"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 20,
    fill: "white",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 15,
    fontSize: 12,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Interview Management"), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 70,
    width: 8,
    height: 30,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    width: 8,
    height: 30,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 70,
    width: 8,
    height: 30,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 8,
    height: 30,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 70,
    width: 8,
    height: 30,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70,
    width: 8,
    height: 30,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 8,
    height: 30,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 70,
    width: 8,
    height: 30,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 70,
    width: 8,
    height: 30,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 70,
    width: 8,
    height: 30,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 70,
    width: 8,
    height: 30,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 70,
    width: 8,
    height: 30,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 110,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Jan"), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 110,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Feb"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 110,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Mar"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 110,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Apr"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 110,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "May"), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 110,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Jun"), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 120,
    width: 8,
    height: 8,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 128,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Scheduled"), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 8,
    height: 8,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 128,
    fontSize: 8,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Completed"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 20,
    fill: "white",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 15,
    fontSize: 12,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Candidate Management"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 80,
    height: 10,
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 38,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "120"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 55,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Next Round"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70,
    width: 30,
    height: 10,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 78,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "45"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 95,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Hired"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110,
    width: 40,
    height: 10,
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 118,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "75"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 135,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Rejected"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 20,
    fill: "white",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 15,
    fontSize: 12,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Key Metrics"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 60,
    height: 40,
    fill: "#eee",
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 55,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Time to Hire"), /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 70,
    fontSize: 14,
    fontFamily: "sans-serif",
    fill: "black"
  }, "45 days"), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 30,
    width: 60,
    height: 40,
    fill: "#eee",
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 55,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Cost per Hire"), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 70,
    fontSize: 14,
    fontFamily: "sans-serif",
    fill: "black"
  }, "$1,200"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90,
    width: 60,
    height: 40,
    fill: "#eee",
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 115,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Open Positions"), /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 130,
    fontSize: 14,
    fontFamily: "sans-serif",
    fill: "black"
  }, "12"), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 90,
    width: 60,
    height: 40,
    fill: "#eee",
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 115,
    fontSize: 10,
    fontFamily: "sans-serif",
    fill: "black"
  }, "Total Applications"), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 130,
    fontSize: 14,
    fontFamily: "sans-serif",
    fill: "black"
  }, "450"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgDashboard1);
export default __webpack_public_path__ + "static/media/Org_Dashboard1.c68a1d89f5f8bedb8fc2e6bcc2c025f1.svg";
export { ForwardRef as ReactComponent };